/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {ActionDefinitionModel} from "./action-definition.model";
import {FormControl, FormGroup} from "@angular/forms";
import {customRequiredValidation} from "@irian-ro/shared-components-module";

export class SubscriptionTypeDtoModel extends JSONable {

  uuid: string | undefined = undefined;

  typeName: string | undefined = undefined;

  subscriptionPrice: string | undefined = undefined;

  subscriptionCurrency: string | undefined = undefined;

  pricePerExtraCredit: number | undefined = undefined;

  isPrivate: boolean | undefined = undefined;

  creditStart: string | undefined = undefined;

  companyType: any;

  legalEntities: {
      companyName: string,
      cui: string,
      uuid: string
    } | undefined = undefined;

  actionDefinitionVos: ActionDefinitionModel[] | undefined = undefined;

  static createForm() {
    return new FormGroup({
      uuid: new FormControl(null),
      typeName: new FormControl(null, [customRequiredValidation('typeName')]),
      subscriptionPrice: new FormControl(null, [customRequiredValidation('subscriptionPrice')]),
      subscriptionCurrency: new FormControl(null, [customRequiredValidation('subscriptionCurrency')]),
      companyType: new FormControl(null, [customRequiredValidation('companyType')]),
      private: new FormControl(false),
      creditStart: new FormControl(null, customRequiredValidation('CreditStart')),
      pricePerExtraCredit: new FormControl(null, customRequiredValidation('PricePerExtraCredit')),
      actionDefinitionVos: new FormControl(null),
      details: new FormControl(null)
    })
  }
}
